import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { App } from './App.js'
import { concluirLogin, ehPopupDaMicrosoft, guardarErroDeLogin, voltandoDoLogin } from './dados/login.js'
import './estilos.css'
// Cedo, antes de qualquer tela: o aviso de "pode instalar" do Android chega uma
// vez só, no carregamento. Ver dados/instalacao.ts.
import './dados/instalacao.js'
import { Auditoria } from './telas/Auditoria.js'
import { Checklists } from './telas/Checklists.js'
import { CriticidadeApia } from './telas/CriticidadeApia.js'
import { Detalhe } from './telas/Detalhe.js'
import { EditorChecklist } from './telas/EditorChecklist.js'
import { Entrar } from './telas/Entrar.js'
import { Inicio } from './telas/Inicio.js'
import { NovaInspecao } from './telas/NovaInspecao.js'
import { Painel } from './telas/Painel.js'
import { Preencher } from './telas/Preencher.js'
import { Usuarios } from './telas/Usuarios.js'

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Em campo a rede é ruim; nada de revalidar a cada foco de janela.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60_000,
      networkMode: 'offlineFirst',
    },
    mutations: { networkMode: 'offlineFirst' },
  },
})

const rotas = createBrowserRouter([
  { path: '/entrar', element: <Entrar /> },
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Inicio /> },
      { path: 'nova', element: <NovaInspecao /> },
      { path: 'inspecao/:id', element: <Preencher /> },
      { path: 'inspecao/:id/ver', element: <Detalhe /> },
      { path: 'painel', element: <Painel /> },
      { path: 'criticidade', element: <CriticidadeApia /> },
      { path: 'checklists', element: <Checklists /> },
      { path: 'checklists/novo', element: <EditorChecklist /> },
      { path: 'checklists/:id', element: <EditorChecklist /> },
      { path: 'usuarios', element: <Usuarios /> },
      { path: 'auditoria', element: <Auditoria /> },
    ],
  },
])

const raiz = createRoot(document.getElementById('raiz')!)

// A volta do login da Microsoft é tratada antes de o roteador existir: ele
// mandaria a raiz para /entrar e apagaria o código que veio no fragmento da URL.
// Ver dados/login.ts.
//
// O popup da busca no diretório volta pelo mesmo caminho, mas não é login: quem
// lê a resposta é a janela que o abriu, e esta só precisa não mexer na URL.
if (ehPopupDaMicrosoft()) {
  raiz.render(<ConcluindoLogin />)
} else if (voltandoDoLogin()) {
  raiz.render(<ConcluindoLogin />)
  concluirLogin()
    .then(() => window.location.replace('/'))
    .catch((e) => {
      guardarErroDeLogin(e)
      window.location.replace('/entrar')
    })
} else {
  raiz.render(
    <StrictMode>
      <QueryClientProvider client={cliente}>
        <RouterProvider router={rotas} />
      </QueryClientProvider>
    </StrictMode>,
  )
}

function ConcluindoLogin() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-marinho px-6 text-center">
      <span className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-limao border-t-transparent" />
      <p className="font-semibold text-white">Concluindo o login…</p>
      <p className="mt-1 text-sm text-marinho-100">Preparando o aplicativo para funcionar sem internet.</p>
    </div>
  )
}
